/**
 * Whether an editor change is the advisor's, and so may be written back.
 * @param params Whether a programmatic write is open, and MDXEditor's initial-normalise flag.
 * @returns True only for a change the advisor made.
 */
export function isAdvisorEdit(params: { isProgrammatic: boolean; isInitialNormalize: boolean }): boolean {
   return !params.isProgrammatic && !params.isInitialNormalize
}
